import { render } from "./TextRule.vue?vue&type=template&id=47222236"
import script from "./TextRule.vue?vue&type=script&lang=js"
export * from "./TextRule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__